import { render, staticRenderFns } from "./on-service-edit-category.vue?vue&type=template&id=33d38872"
import script from "./on-service-edit-category.vue?vue&type=script&lang=js"
export * from "./on-service-edit-category.vue?vue&type=script&lang=js"
import style0 from "./on-service-edit-category.vue?vue&type=style&index=0&id=33d38872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports